import React from 'react';
import styles from './add-edit-product.scss';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import PriceRange from './price-range/PriceRange';

export default (props) => {
	const renderChildElements = (formElements) => {
		return formElements.map((cur, index) => {
			if (cur.hide) {
				return null;
			}
			if (cur.customJSX) {
				return cur.customJSX;
			}
			if(cur.priceRange){
				return <PriceRange onRightIconClick={cur.onRightIconClick} showArrow={cur.showArrow} rightIconClass={cur.rightIconClass} inputObj={cur.inputObj} hideDash={cur.hideDash} holderClass={cur.holderClass} errors={cur.error} doNotCenter={cur.doNotCenter} />
			}
			if(cur.formElements){
				return (
					<div className={cur.holderClass}>
						{renderChildElements(cur.formElements)}
					</div>
				)
			}
			if (props.isTemplate && !cur.editableForTemplate) {
				return (
					<div
						dangerouslySetInnerHTML={{ __html: cur.input.value }}
						className={styles['template-field'] + ' ' + styles['marginLR15']}
					/>
				);
			}
			else {
				let component = (
					<InputWithMovingLabel
						ref={r => cur.inputRef?cur.inputRef.current[cur.key]=r:null}
						rightSection={cur.rightSection}
						showBottomSection={cur.showBottomSection}
						bottomSection={cur.bottomSection}
						inputGroupProps = {cur.inputGroupProps}
						label={cur.label}
						input={cur.input}
						key={index}
						as={cur.as}
						errorMessage={props.errors?.[cur.key]}
						errClass={cur.errorClass}
						showArrow={cur.showArrow}
						rightIconClass={cur.rightIconClass}
						onRightIconClick={cur.onRightIconClick}
						className={(cur.key == 'sellingPrice' &&  cur.input.value != ' ')? 'rupee-holder' : ''}
						disableMovingLabel={cur.disableMovingLabel}
						dontMoveLabel={cur.dontMoveLabel}
						holderClass={(cur.holderClass || '') + " input-with-moving-label"}
						prepend={cur.prepend}
						append={cur.append}
						hidePrependBar={cur.hidePrependBar}
						showRightSectionAlways={cur.showRightSectionAlways}
						labelAlwaysUp={cur.labelAlwaysUp}
						showPreTextWithoutFocus={cur.showPreTextWithoutFocus}
						infoMessage={cur.infoMessage}
					/>
				)
				if(!cur.ignoreParentClass){
					component = (
						<div className={`${styles['marginLR15']} ${cur.parentClass ? cur.parentClass : ''}`} ref={cur.parentRef}>
							{component}
						</div>
					)
				}
				return component;
			}
		});
	}

	return renderChildElements(props.formElements);
}
